module.exports = __webpack_public_path__ + "img/type--4-spans--multiple-lang--de.e8decb36.jpg";